import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import configureStore from './store/store';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import theme from './assets/styles/theme';
import StylesProvider from '@material-ui/styles/StylesProvider';
import { jssPreset } from '@material-ui/styles';
import rtl from 'jss-rtl';
import { create } from 'jss';
import { pageView } from './shared/services/analytics/GAnalytics';
import { AppProvider } from './shared/services/general/app-context';
import ScrollToTop from './shared/services/general/scroll-to-top';

// Async CSS Load
import('./assets/styles/base.scss').then();
import('./assets/styles/fonts/fonts.scss').then();

function Main() {
	const store = configureStore();
	const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

	useEffect(() => {
		const trackPageView = async () => {
			try {
				await pageView("/");
			} catch (error) {
				console.error('Analytics error:', error);
			}
		};

		trackPageView().then();
	}, []);

	return (
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<StylesProvider jss={jss}>
					<BrowserRouter>
						<ScrollToTop>
							<AppProvider>
								<App />
							</AppProvider>
						</ScrollToTop>
					</BrowserRouter>
				</StylesProvider>
			</ThemeProvider>
		</Provider>
	);
}

ReactDOM.render(<Main />, document.getElementById('root'));